'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.config.preconditions.config', [])
  .provider('preconditionTypeConfig', function() {

    var preconditionTypes = [];

    function registerPreconditionType(config) {
      preconditionTypes.push(config);
    }

    function listPreconditionTypes() {
      return angular.copy(preconditionTypes);
    }

    this.registerPreconditionType = registerPreconditionType;

    this.$get = function() {
      return {
        listPreconditionTypes: listPreconditionTypes
      };
    };

  }
);



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/preconditions/preconditionTypeConfig.provider.js